import { memo } from 'react'
import { CircularProgress } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import type { UserAdded } from './constants'
import { hasAnsweredTest } from './test-status'
import { ContainerActions, DeleteActionButton } from './styled'

interface DeleteUserActionProps extends UserAdded {
  selectedItems: Set<number>
  deletingUserId: string | null
  isDeletingUser: boolean
  isAddingAnyUser: boolean
  onRemoveUser: (document: string) => void
}

const DeleteUserAction = memo(
  ({ selectedItems, deletingUserId, isDeletingUser, isAddingAnyUser, onRemoveUser, ...item }: DeleteUserActionProps) => {
    const documentId = item.document
    const hasAnswers = hasAnsweredTest(item.test_statuses, item.test_sent)
    const isDeleting = deletingUserId === documentId
    const isDisabled = isDeletingUser || isAddingAnyUser
    const actionLabel = isDeleting ? 'Eliminando...' : 'Eliminar'

    if (selectedItems.size > 0 || hasAnswers) return <ContainerActions />

    return (
      <ContainerActions title={actionLabel}>
        <DeleteActionButton
          type="button"
          disabled={isDisabled}
          aria-label={actionLabel}
          onClickCapture={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onRemoveUser(documentId)
          }}
          style={{
            cursor: isDisabled ? 'default' : 'pointer',
            opacity: isDisabled && !isDeleting ? 0.6 : 1,
          }}
        >
          {isDeleting ? <CircularProgress size={18} color="error" /> : <DeleteOutlineIcon fontSize="small" />}
        </DeleteActionButton>
      </ContainerActions>
    )
  }
)

export default DeleteUserAction
